import React, {useEffect, useState} from 'react';
import * as Common from '../common/app_common.js';
import {Title} from '../common/component_common.js';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Modal from 'react-bootstrap/Modal';
import { Button, Dropdown } from 'react-bootstrap';
import '../common/css/dashboard.css'

const Example = ({show, handleClose}) => {
    // 초기 아이템 상태
    const initialItems = [
        { id: 'item-0', content: 'System', type: 'full md' },
        { id: 'item-1', content: 'Status', type: 'full sm' },
        { id: 'item-2', content: 'Service Info', type: 'half lg' },
        { id: 'item-3', content: 'Module Status', type: 'half lg' },
        { id: 'item-4', content: 'Config', type: 'half lg' },
        { id: 'item-5', content: 'Software Infomation', type: 'half lg' },
        { id: 'item-6', content: 'CPU', type: 'half lg' },
        { id: 'item-7', content: 'MEM', type: 'half lg' },
        { id: 'item-8', content: 'DISK', type: 'half lg' },
        { id: 'item-9', content: 'Mux Output', type: 'half lg' },
        { id: 'item-10', content: 'LLS', type: 'half lg' },
    ];

    const onClickCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
    }

    // Enable 영역 아이템 상태
    const [enableItems, setEnableItems] = useState(initialItems);

    // Disable 영역 아이템 상태
    const [disableItems, setDisableItems] = useState([]);

    // DragDropContext의 onDragEnd 핸들러
    const onDragEnd = (result) => {
        const { source, destination } = result;
        // 드래그가 끝난 위치가 없거나 시작과 끝이 같으면 종료
        if (!destination || destination.index === source.index) {
            return;
        }

        // 이동한 아이템 객체
        const movedItem = source.droppableId === 'enable' ? enableItems[source.index] : disableItems[source.index];

        // Enable -> Disable 이동
        if (source.droppableId === 'enable' && destination.droppableId === 'disable') {
            setEnableItems(enableItems.filter((item, index) => index !== source.index));
            setDisableItems([...disableItems, movedItem]);
        }
        // Disable -> Enable 이동
        else if (source.droppableId === 'disable' && destination.droppableId === 'enable') {
            setDisableItems(disableItems.filter((item, index) => index !== source.index));
            setEnableItems([...enableItems, movedItem]);
        }
        // 다른 경우 (같은 영역에서 이동하는 경우)
        else {
            // 이동한 아이템이 있는 영역의 아이템들 배열
            const itemsArray = source.droppableId === 'enable' ? enableItems : disableItems;
            // 아이템들 배열에서 이동한 아이템 제외한 새로운 배열 생성
            const newItems = itemsArray.filter((item, index) => index !== source.index);
            // 이동한 위치에 아이템 삽입
            newItems.splice(destination.index, 0, movedItem);

            // 이동한 영역에 따라 상태 업데이트
            if (source.droppableId === 'enable') {
            setEnableItems(newItems);
            } else {
            setDisableItems(newItems);
            }
        }
    };

    return (
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            backdrop="static"
            size="lg"
            // fullscreen={true}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Widget Config</h6>
                <Button variant='close' className="btn-close-white" onClick={closeModal}></Button>
            </Modal.Header>
            <Modal.Body>
                <DragDropContext onDragEnd={onDragEnd}>
                    <div className="d-flex justify-content-between mt-2">
                    {/* Enable 영역 */}
                    <Droppable droppableId="enable">
                        {(provided) => (
                            <div className='drag-container me-2'>
                                <h2>Enable</h2>
                                <div
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                    className='d-flex flex-wrap drag-section enable me-2'
                                >
                                    {enableItems.map((item, index) => (
                                    <Draggable key={item.id} draggableId={item.id} index={index}>
                                        {(provided) => (
                                            <div
                                                className={`drag-move ${item.type} bg-primary bg-opacity-75`}
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                            >
                                                <div className='drag-text text-white'>{item.content}</div>
                                            </div>
                                        )}
                                    </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            </div>
                        )}
                    </Droppable>
                    {/* Disable 영역 */}
                    <Droppable droppableId="disable">
                        {(provided) => (
                            <div className='drag-container me-2'>
                                <h2>Disable</h2>
                                <div
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                    className='d-flex flex-wrap drag-section disable'
                                >
                                    {disableItems.map((item, index) => (
                                    <Draggable key={item.id} draggableId={item.id} index={index}>
                                        {(provided) => (
                                            <div
                                            className={`drag-move ${item.type} bg-primary bg-opacity-25`}
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                            >
                                                <div className='drag-text text-white text-opacity-50'>{item.content}</div>
                                            </div>
                                        )}
                                    </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            </div>
                        )}
                    </Droppable>
                    </div>
                </DragDropContext>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>CLose</Button>
            </Modal.Footer>
        </Modal>
    );
};

const PageTest = () => {

    const [show, setShow] = useState(false);
    const handleShow = () => {setShow(true)};
    const handleClose = () => {setShow(false)};

    return (
        <>
            <Title title='Test Page'></Title>
            <Button variant='primary' onClick={handleShow}>Show Drag&Drop Example</Button>
            <Example show={show} handleClose={handleClose}/>
        </>
    )
}

export default PageTest;